// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import {Divider, RadioGroup, FormControlLabel, Radio} from '@material-ui/core';
import {colors} from '../../../assets/styles/colors';

import {
  MAP_PAYMENT_METHOD,
  type Currency,
  type PaymentMethod,
} from '../../../entities';

import {connect} from 'react-redux';

import type {RootState} from '../../index';
import {typeUseFormRegister} from 'react-hook-form';

export default connect(
  (state: RootState) => ({
    paymentMethods: state.paymentMethodConfig.paymentMethods,
    country: state.country.country,
    total: state.manualOrder.orderSummary
      ? state.manualOrder.orderSummary.total
      : '',
    currency: state.currency.currency,
  }),
  null
)(PaymentForm);

type Props = {|
  paymentMethods?: PaymentMethod[],
  paymentMethodSelected?: string,
  setPaymentMethodSelected: (paymentMethod: string) => void,
  register?: typeUseFormRegister<typeof HTMLInputElement> | null,
  errors: {[key: string]: {type: string, message: string}},
  total?: string,
  currency?: Currency,
  orderPaid?: boolean,
  setOrderPaid: (checked: boolean) => void,
  tempOrderInfo?: Object,
  setTempOrderInfo?: (tempOrderInfo: Object) => void,
|};

const useStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(1, 0),
    background: colors.grey200,
    width: '100%',
  },
  deliveryRadio: {
    // margin: theme.spacing(1, 0),
  },
  paymentMethodLabel: {
    color: colors.grey800,
  },
  paymentMethodLabelSelected: {
    fontWeight: 600,
  },
  paymentMethodDescription: {
    marginLeft: 32,
    color: colors.grey600,
    fontSize: '0.875rem',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
    wordBreak: '200px',
  },
  paymentMethodDetail: {
    marginLeft: 32,
  },
  orderPaidCheckbox: {
    marginTop: -8,
  },
  orderPaidCheckboxIcon: {
    // padding:''
  },
  orderPaidCheckboxLabel: {
    fontSize: '0.875rem',
    color: colors.grey800,
  },
  textField: {
    margin: theme.spacing(1, 0),
    width: '100%',
  },
  textInput: {
    borderRadius: '8px',
  },
  textInputLabel: {
    color: colors.grey600,
  },
}));

function PaymentForm(props: Props) {
  const {
    paymentMethods,
    paymentMethodSelected,
    setPaymentMethodSelected,
    // register,
    // errors,
    // total,
    // currency,
    // orderPaid,
    // setOrderPaid,
    // tempOrderInfo,
    // setTempOrderInfo,
  } = props;

  const classes = useStyles();

  return (
    <RadioGroup
      name="paymentMethodSelected"
      value={paymentMethodSelected}
      onChange={e => setPaymentMethodSelected(e.target.value)}
    >
      {paymentMethods &&
        paymentMethods
          .filter(pm => pm.enabled)
          .map((pm: PaymentMethod, index: number) => {
            if (!pm.enabled) return null;
            let paymentName = pm.displayName;
            if (pm.paymentMethod === 'CONTINUE_TO_CHAT')
              paymentName = MAP_PAYMENT_METHOD.CONTINUE_TO_CHAT;
            if (pm.paymentMethod === 'PAY_ON_DELIVERY')
              paymentName = MAP_PAYMENT_METHOD.PAY_ON_DELIVERY;
            if (pm.paymentProcessor.code === 'STRIPE_CHECKOUT') {
              paymentName = 'Stripe';
            }

            return (
              <React.Fragment key={index}>
                {index > 0 && <Divider className={classes.divider} />}
                <FormControlLabel
                  classes={{
                    root: classes.deliveryRadio,
                    label:
                      paymentMethodSelected === pm.id
                        ? classes.paymentMethodLabelSelected
                        : '',
                  }}
                  value={pm.id}
                  control={<Radio color="primary" />}
                  label={paymentName}
                />
              </React.Fragment>
            );
          })}
    </RadioGroup>
  );
}

PaymentForm.propTypes = {
  paymentMethods: PropTypes.array,
  paymentMethodSelected: PropTypes.string,
  setPaymentMethodSelected: PropTypes.func.isRequired,
  register: PropTypes.oneOfType([
    PropTypes.func.isRequired,
    PropTypes.shape({current: PropTypes.instanceOf(HTMLInputElement)})
      .isRequired,
  ]),
  errors: PropTypes.object,
  total: PropTypes.string,
  currency: PropTypes.object,
  orderPaid: PropTypes.bool,
  setOrderPaid: PropTypes.func,
  tempOrderInto: PropTypes.object,
  setTempOrderInfo: PropTypes.func,
};
